import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/pages/startpage/src/assets/app-store-badge-en.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')